// Meta Pixel tracking utilities
export const initMetaPixel = (pixelId: string) => {
  // Check if fbq already exists
  if (typeof window !== 'undefined' && !(window as any).fbq) {
    // Meta Pixel Code
    ;(function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      }
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = !0
      n.version = '2.0'
      n.queue = []
      t = b.createElement(e)
      t.async = !0
      t.src = v
      s = b.getElementsByTagName(e)[0]
      s.parentNode.insertBefore(t, s)
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
    )

    // Initialize pixel
    ;(window as any).fbq('init', pixelId)
    ;(window as any).fbq('track', 'PageView')
  }
}

// Track custom events
export const trackMetaEvent = (eventName: string, data?: any) => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;(window as any).fbq('track', eventName, data)
  }
}
